// import facebookLogo from "assets/images/facebook.svg";
// import twitterLogo from "assets/images/twitter.svg";

export function Footer() {
  return (
    <footer className="w-full h-32 shrink-0 bg-main text-sm">
      <div className="flex flex-row space-x-8 w-2/3 mx-auto pt-4 text-white">
        <a href="https://www.lu.ch" className="font-bold">
          © {new Date().getFullYear()} Kanton Luzern
        </a>
        <ul className="flex flex-col space-y-1">
          <li>
            <a
              href="https://rawi.lu.ch/impressum"
              rel="noreferrer"
              target="_blank"
              className="text-white"
            >
              Impressum
            </a>
          </li>
          <li>
            <a
              href="https://rawi.lu.ch/disclaimer"
              rel="noreferrer"
              target="_blank"
              className="text-white"
            >
              Disclaimer
            </a>
          </li>
        </ul>
        <ul className="flex flex-col space-y-1">
          <li>
            <a
              href="https://rawi.lu.ch"
              className="text-white"
              rel="noreferrer"
              target="_blank"
            >
              rawi
            </a>
          </li>
          <li>
            <a
              href={process.env.REACT_APP_URL_URBAN_PLANNING}
              className="text-white"
              rel="noreferrer"
              target="_blank"
            >
              Orts- und Regionalplanung
            </a>
          </li>
          <li>
            <a
              href="https://geoportal.lu.ch/"
              className="text-white"
              rel="noreferrer"
              target="_blank"
            >
              Geoportal
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
}
